(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pvl-product-detail"] && !Shopify.designMode) return;
  try {
    /* Nutrition facts follows the variant. Each label carries the ids of the
     variants that use it as ",id,id,"; show the one for the new variant, name
     the variant in the box above it, and hide the whole item when the variant
     has no label. `:updated` fires after the theme's own form work. */
  document.addEventListener('venue:variant:updated', function (event) {
    var detail = event.detail || {};
    if (!detail.product || !detail.variant) return;
    var needle = ',' + detail.variant.id + ',';

    document
      .querySelectorAll('[data-pvl-nutrition][data-product-id="' + detail.product.id + '"]')
      .forEach(function (item) {
        var found = false;
        item.querySelectorAll('[data-nf-panel]').forEach(function (panel) {
          var match = panel.getAttribute('data-variant-ids').indexOf(needle) !== -1;
          panel.hidden = !match;
          if (match) found = true;
        });
        item.hidden = !found;

        var name = item.querySelector('[data-nf-variant]');
        if (name && found && detail.variant.title) name.textContent = detail.variant.title;
      });
  });
  } catch(e) { console.error(e); }
})();

})();
